import { notNil } from "core/utils";
import { ReactNode } from "react";
import { Link, LinkProps, To } from "react-router-dom";
import { useRouting } from "../../hooks/with-routing";
import "./buttons.scss";

interface ButtonProps {
	className?: string;
	onClick?: VoidFunction;
	children: ReactNode;
	disabled?: boolean;
	hidden?: boolean;
}

interface LinkButtonProps extends ButtonProps {
	to: To;
}

const merge = (props: ButtonProps, ...classes: (string | undefined)[]) => (
	{ ...props, className: classes.filter(notNil).join(" ") }
);

const BaseButton = (props: ButtonProps) => (
	<button
		type="button"
		className={props.className}
		disabled={props.disabled}
		hidden={props.hidden}
		onClick={props.onClick}
	>
		{props.children}
	</button>
);

export const PrimaryButton = (props: ButtonProps) => (
	<BaseButton {...merge(props, "btn-primary", props.className)} />
);

export const SecondaryButton = (props: ButtonProps) => (
	<BaseButton {...merge(props, "btn-secondary", props.className)} />
);

export const LightButton = (props: ButtonProps) => (
	<BaseButton {...merge(props, "btn-light", props.className)} />
);

export const LinkButton = (props: ButtonProps) => (
	<BaseButton {...merge(props, "btn-link", props.className)} />
);

export const PrimaryLink = (props: LinkButtonProps) => (
	<Link to={props.to}>
		<PrimaryButton {...props} />
	</Link>
);

export const LightLink = (props: LinkButtonProps) => (
	<Link to={props.to}>
		<LightButton {...props} />
	</Link>
);

export const LightRoutingLink = (props: LinkButtonProps) => {
	const createPath = useRouting.use.createPath();
	const to = createPath(props.to as string);
	return (
		<LightLink {...props} to={to} />
	);
};

export const LinkRouting = (props: LinkProps & React.RefAttributes<HTMLAnchorElement>) => {
	const createPath = useRouting.use.createPath();
	const to = createPath(props.to as string);
	return (
		<Link {...props} to={to} />
	);
};